import { render, staticRenderFns } from "./TrademarkSearchForm.vue?vue&type=template&id=b8c24802&"
import script from "./TrademarkSearchForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchForm.vue?vue&type=style&index=0&id=b8c24802&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports